import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Upload } from 'components';
import { useForm } from 'antd/lib/form/Form';
import { content} from './content';
import { isBeneficiary } from 'utils';
import { flattenDocs } from '../../utils';

const DocsSupplier = ({ group }) => {

  const [form] = useForm();
  const user = useSelector(state => state.user);
  const dispatch = useDispatch();
  const docs = useSelector(state => state.forms['documents']);
  const flatDocs = flattenDocs(docs);

  return (
    <div className='mt-1'>
          {content().map((item, index) => {
            return (
              <Upload item={item} subFileCode={item.fileCode}  key={index} group={'documents'} />
            );
          })}
        </div>
      ) 
};

DocsSupplier.propTypes = {
  group: PropTypes.string.isRequired,
};

export default DocsSupplier;
